import { ElMessage } from 'element-plus'

const state = {
  selectProjectId: {},  // 选中的项目ID  用于查询列表
  selectDeviceGroupId: {},  // 选中的设备分组ID  用于查询列表
}

// 同步操作
const mutations = {
  SET_SELECTED_PROJECT(state, data = null) {
    state.selectProjectId = data
  },
  SET_SELECTED_DEVICE_GROUP(state, data = null) {
    state.selectDeviceGroupId = data
  },
}

// 异步操作
const actions = {
  // 设置选中的项目ID
  setSelectProject({ commit }, data = null) {
    commit('SET_SELECTED_PROJECT', data)
  },
  // 设置选中的设备分组信息
  setSelectDeviceGroup({ commit }, data = null) {
    commit('SET_SELECTED_DEVICE_GROUP', data)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
